import React from 'react';
import styled from 'styled-components';
import { VistaWordmark } from '@99designs/branding';
import {
    FacebookLogo,
    NationbuilderLogo,
    PreziLogo,
    SquareWordmark,
    SquarespaceWordmark,
    WixLogo,
} from '@99designs/spa-common';
import { Partner } from '@99designs/spa-common';
import { InlinedSvg } from '@99designs/spa-common';

const SVG = styled(InlinedSvg)<{ width: number }>`
    width: ${({ width }) => width}px;
`;

export function PartnerLogo({ partner, width }: { partner: Partner; width?: number }) {
    switch (partner) {
        case Partner.NationBuilder:
            return (
                <SVG width={width ?? 160} data-testid="partner-logo">
                    {NationbuilderLogo}
                </SVG>
            );
        case Partner.Square:
            return (
                <SVG width={width ?? 120} data-testid="partner-logo">
                    {SquareWordmark}
                </SVG>
            );
        case Partner.Prezi:
            return (
                <SVG width={width ?? 120} data-testid="partner-logo">
                    {PreziLogo}
                </SVG>
            );
        case Partner.Facebook:
            return (
                <SVG width={width ?? 150} data-testid="partner-logo">
                    {FacebookLogo}
                </SVG>
            );
        case Partner.Squarespace:
            return (
                <SVG width={width ?? 230} data-testid="partner-logo">
                    {SquarespaceWordmark}
                </SVG>
            );
        case Partner.Wix:
            return (
                <SVG width={width ?? 78} data-testid="partner-logo">
                    {WixLogo}
                </SVG>
            );
        case Partner.Vistaprint:
            return <VistaWordmark data-testid="partner-logo" />;
        default:
            return null;
    }
}
